import React from "react"

const QuiverLeft = ({
  colors = [
    "#3C2415",
    "#8B5E3C",
    "#C49A6C",
    "#6E634F",
    "#4076B7",
    "#43A3DB",
    "#9F7731",
    "#359C5A",
    "#63C298"
  ]
}) => {
  return (
    <g id="QuiverLeft">
      <path
        fill={colors[0]}
        d="M62.6,103.4L57,80.5v-0.2l0,0c0-0.3,0-0.7,0.1-1l-0.9-3.2l-0.9-1.7c-0.1-0.3-0.2-0.6-0.3-0.9L54.9,72 l0.5,0.4l0.5-0.1l0.2-0.3l-0.4-0.7c-0.1-0.3-0.2-0.6-0.2-0.9l-0.1-1.5l0.5,0.4l0.5-0.1l0.3-0.5l0.6,1.2c0.1,0.3,0.2,0.6,0.2,0.9 v0.7c0,0,0.3,0.3,0.4,0.3l0.5-0.1l0,0l-0.6-1.5c-0.2-0.2-0.3-0.5-0.3-0.8v-1.5c0,0,0.5,0.4,0.5,0.5l0.5-0.1l0.3-0.5l0.6,1.3 c0.1,0.3,0.2,0.6,0.2,0.9l-0.1,0.9l0.2,0.2l0.5-0.1l0.3-0.5l0.6,1.3c0.1,0.3,0.2,0.6,0.2,0.9l-0.2,1.5l0.8,3.9 c0.1,0,0.1,0.1,0.2,0.2h0.1l0.1,0.2c0.1,0.1,5.5,11.8,2.7,22.4v0.1L62.6,103.4z"
      />
      <path
        fill={colors[1]}
        d="M64.5,100.6l-1.8,2.2l-5.5-22.4l4.6-2.1C61.9,78.3,67.4,89.9,64.5,100.6z"
      />
      <path
        opacity="0.62"
        fill={colors[2]}
        d="M57.9,83.1l4.9,19.9l1.8-2.2c2-7.5-0.1-15.5-1.6-19.5 c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.7-0.2-1.1-0.4-1.6c-0.1-0.3-0.2-0.5-0.3-0.6c0,0,0,0-0.1,0c0.2,0.8,0.3,1.4,0.5,2.3 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2-0.9-0.3-1.5-0.5-2.2c0,0.1-0.1,0.2-0.1,0.3c0.1,0.7,0.3,1.2,0.5,2.1C62,82,61.9,82,61.8,82.1 c-0.2-0.8-0.3-1.3-0.4-1.9c0,0.1-0.1,0.1-0.1,0.2c0.1,0.5,0.2,1.1,0.4,1.8c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.7-0.3-1.2-0.4-1.7 c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.5,0.2,1,0.4,1.6c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.6-0.3-1.1-0.4-1.6c-0.1,0-0.1,0.1-0.2,0.1 c0,0,0,0,0,0.1c0.1,0.5,0.2,1,0.3,1.6c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.6-0.2-1.1-0.4-1.6c-0.1,0-0.1,0-0.2,0.1 c0.1,0.5,0.2,1,0.4,1.6c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.7-0.3-1.2-0.4-1.7c0,0-0.1,0.1-0.2,0.1c0.1,0.5,0.2,1,0.4,1.7 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.7-0.3-1.2-0.4-1.7l0,0h-0.1c0.1,0.5,0.2,1.1,0.4,1.8c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.2-0.7-0.3-1.4-0.4-1.9c-0.1,0-0.1,0-0.2,0c0.1,0.6,0.3,1.3,0.5,2.1c-0.1,0.1-0.2-0.3-0.4-0.3c-0.2-0.9-0.3-1.2-0.4-1.8 c-0.1,0-0.1,0-0.2,0c0.2,0.7,0.2,0.8,0.4,1.7c-0.1,0.1-0.3-0.4-0.4-0.3c-0.2-1.1-0.2-0.8-0.4-1.6c-0.1,0-0.1,0-0.2-0.1 c0.2,0.9,0.1,0.5,0.4,1.6C57.9,83,57.8,82.7,57.9,83.1z M61.8,87.8c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.1-0.3,0.2-0.3,0.2 c-0.2,0-0.5,0-0.6-0.1s-0.3-0.2-0.4-0.4c-0.1-0.1,0.3-0.2,0.3-0.2C61.4,87.7,61.6,87.7,61.8,87.8z M63.6,87.6 c-0.7,0.3-2.3,0-2.6-0.7c-0.3-0.7-0.5-2,0.4-2.2c0,0,2.1,1.2,2.2,1.2c-0.2-0.4-1.6-1.7-1.8-2c-0.1-0.1,0.8-0.3,0.9-0.1 C63.1,84.4,64.8,87.1,63.6,87.6z M64.5,95.1c-0.1,0.2-1,1.3-1,1.1c0.6-2.4-0.3-4.9-0.8-7.3c0-0.1,1-1.5,1.4-0.2 C64.7,91,65,92.7,64.5,95.1z M62.7,101.1c0.1-0.5,0.3-1,0.4-1.6c-0.2,0-0.3-0.1-0.1-0.1h0.1v-0.1l0,0c-0.1-0.3-0.2-0.7-0.3-1 c-0.2,0-0.3-0.1-0.1-0.1h0.1c0-0.2,0-0.3,0-0.5c-0.3,0-0.7-0.1-0.4-0.2c0.1,0,0.3,0,0.5,0c0.1-0.2,0.2-0.3,0.4-0.4 c-0.3,0-0.7-0.1-0.4-0.2c0.1,0,0.6,0,0.7,0.1v-0.1c0-0.1,0.9-0.3,1,0s0.1,0.6-0.1,0.9c0,0.2,0,0.4,0,0.5l0,0 c0.3,0,0.6,0.1,0.3,0.2c-0.1,0-0.2,0-0.3,0c0,0.1,0,0.2-0.1,0.4c0.2,0,0.4,0.1,0.2,0.1c0,0-0.1,0-0.2,0c-0.1,0.1-0.1,0.2-0.2,0.3 c-0.1,0.6-0.2,1.2-0.4,1.8C63.6,101.4,62.7,101.2,62.7,101.1z"
      />
      <path
        fill={colors[0]}
        d="M57.3,80.5c-0.8-2.4,3.6-3.8,4.6-2.1C62.8,80,58.2,83.5,57.3,80.5z"
      />
      <path
        fill={colors[0]}
        d="M58.8,81.6c0.2,1.5,0.6,3,0.9,4.5c0.4,1.5,0.7,2.9,0.9,4.4c0.3,1.5,0.7,3,1,4.5s0.7,2.9,1,4.4l0,0 c0.1,0.6,0.1,1.1,0.2,1.7c0,0.6,0.1,1.2-0.1,1.7l0,0c0.2-0.6,0.1-1.1,0.1-1.7s-0.1-1.1-0.1-1.7l0,0l0,0c-0.3-1.5-0.6-3-0.9-4.4 c-0.3-1.5-0.7-2.9-1-4.4c-0.4-1.5-0.6-3-0.9-4.4C59.6,84.5,59.2,83.1,58.8,81.6L58.8,81.6z"
      />
      <path
        fill="none"
        d="M59.1,73.5l1.5,7.1c-0.2,0.1-0.3,0.2-0.5,0.3L59,74.8L59.1,73.5z"
      />
      <path
        fill={colors[3]}
        d="M58.9,81.4l-2.1-8.6l0.1,0.2l-0.6-2.6c0-0.1-0.1-0.2-0.1-0.3L56,69.5l0.4-0.1l0.1,0.2 c-0.1,0.2-0.1,0.5,0,0.7l0.6,2.6v-0.6l2.2,9C59.2,81.3,59.1,81.3,58.9,81.4z"
      />
      <path
        fill={colors[4]}
        d="M55.9,71c-0.1-0.2-0.2-0.5-0.2-0.8l-0.1-0.9c0.2,0.2,0.3,0.4,0.5,0.7l0.7,2.7L55.9,71z"
      />
      <path
        fill={colors[4]}
        d="M56.9,72.9l-0.1-0.2L56.1,70c0,0.1,0.1,0.2,0.1,0.3L56.9,72.9z"
      />
      <path
        fill={colors[5]}
        d="M56.6,69.2L57,70c0.1,0.2,0.2,0.5,0.2,0.8l-0.1,1.6l-0.6-2.8C56.5,69.4,56.6,69.3,56.6,69.2z"
      />
      <path
        fill={colors[5]}
        d="M56.5,70.3c-0.1-0.2-0.1-0.5,0-0.7l0.7,2.7v0.6L56.5,70.3z"
      />
      <path
        fill={colors[6]}
        d="M56.5,76l-0.7-2.6c0-0.1-0.1-0.2-0.1-0.3l-0.2-0.5l0.4-0.1l0.1,0.2c0,0.2-0.1,0.5,0,0.7l0.7,2.6v-0.6 l1.7,6c-0.2,0-0.4-0.1-0.5-0.2l-1.5-5.3L56.5,76z"
      />
      <path
        fill={colors[7]}
        d="M55.5,74.2c-0.1-0.2-0.2-0.5-0.2-0.8l-0.1-0.9c0.2,0.2,0.4,0.4,0.5,0.7l0.7,2.7L55.5,74.2z"
      />
      <path
        fill={colors[7]}
        d="M56.5,76l-0.1-0.2l-0.7-2.7c0,0.1,0.1,0.2,0.1,0.3L56.5,76z"
      />
      <path
        fill={colors[8]}
        d="M56.2,72.3l0.4,0.8c0.1,0.2,0.2,0.5,0.2,0.8v1.6l-0.7-2.7C56.1,72.5,56.1,72.4,56.2,72.3z"
      />
      <path
        fill={colors[8]}
        d="M56,73.4c-0.1-0.2-0.1-0.5,0-0.7l0.7,2.7V76L56,73.4z"
      />
      <path
        fill={colors[3]}
        d="M59.1,73.5v-0.2c0-0.3,0-0.5-0.1-0.8l-0.2-0.4l-0.1-0.4l0.1,0.2l-0.5-2.6c0-0.1-0.1-0.2-0.1-0.3l-0.1-0.6 l0.5-0.1v0.2c-0.1,0.2-0.1,0.5,0,0.7l0.5,2.6l0.1-0.6l1.8,9c-0.1,0.1-0.3,0.2-0.4,0.3L59.1,73.5z"
      />
      <path
        fill={colors[4]}
        d="M57.9,70.1c-0.1-0.2-0.2-0.5-0.2-0.8v-0.9c0.2,0.2,0.3,0.4,0.4,0.7l0.6,2.7L57.9,70.1z"
      />
      <path
        fill={colors[4]}
        d="M58.8,72l-0.1-0.2l-0.6-2.7c0,0.1,0.1,0.2,0.1,0.3L58.8,72z"
      />
      <path
        fill={colors[5]}
        d="M58.7,68.2l0.4,0.8c0.1,0.2,0.2,0.5,0.1,0.8l-0.1,1.5l-0.6-2.7C58.6,68.5,58.6,68.3,58.7,68.2z"
      />
      <path
        fill={colors[5]}
        d="M58.5,69.3c0-0.2,0-0.5,0-0.7l0.6,2.7L59,72L58.5,69.3z"
      />
      <path
        fill={colors[6]}
        d="M61.4,79.8l-1-5.3l0.1,0.2L60,72.1c0-0.1-0.1-0.2-0.1-0.3l-0.1-0.6l0.5-0.1v0.2c-0.1,0.2-0.1,0.5,0,0.7 l0.5,2.6l0.1-0.6l1,5.1C61.7,79.4,61.5,79.6,61.4,79.8z"
      />
      <path
        fill={colors[7]}
        d="M59.6,72.8c-0.1-0.2-0.2-0.5-0.2-0.8v-0.9c0.2,0.2,0.3,0.4,0.4,0.7l0.5,2.7L59.6,72.8z"
      />
      <path
        fill={colors[7]}
        d="M60.4,74.7l-0.1-0.2l-0.5-2.7c0,0.1,0.1,0.2,0.1,0.3L60.4,74.7z"
      />
      <path
        fill={colors[8]}
        d="M60.4,70.9l0.4,0.8c0.1,0.2,0.2,0.5,0.1,0.8L60.7,74l-0.5-2.7C60.2,71.2,60.3,71,60.4,70.9z"
      />
      <path
        fill={colors[8]}
        d="M60.2,72c0-0.2,0-0.5,0-0.7l0.5,2.7l-0.1,0.6L60.2,72z"
      />
      <path
        fill={colors[6]}
        d="M58.8,75.5l0.1-0.6L60,81c-0.1,0.1-0.3,0.1-0.4,0.2l-1.1-5.8l0.1,0.2L58.1,73c0-0.1-0.1-0.2-0.1-0.3 L57.9,72l0.5-0.1v0.2c-0.1,0.2-0.1,0.5,0,0.7L58.8,75.5z"
      />
      <path
        fill={colors[7]}
        d="M57.8,73.6c-0.1-0.2-0.2-0.5-0.2-0.8v-0.9c0.2,0.2,0.3,0.4,0.4,0.7l0.5,2.7L57.8,73.6z"
      />
      <path
        fill={colors[7]}
        d="M58.6,75.5L58.6,75.5L58,72.7c0,0.1,0.1,0.2,0.1,0.3L58.6,75.5z"
      />
      <path
        fill={colors[8]}
        d="M58.9,74.9l-0.5-2.7c0-0.1,0.1-0.3,0.2-0.4l0.2,0.5l0.3,1.3L58.9,74.9z"
      />
      <path
        fill={colors[8]}
        d="M59.1,73.3v0.2l-0.3-1.3l0.2,0.4C59.1,72.8,59.1,73.1,59.1,73.3z"
      />
      <path
        fill={colors[8]}
        d="M58.8,75.5l-0.5-2.6c0-0.2,0-0.5,0-0.7l0.5,2.7V75.5z"
      />
    </g>
  )
}

export default QuiverLeft
